import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

export function useDeleteFileMutation() {
    return useMutation({
        mutationFn: async (fileId: string) => {
            const res = await apiClient.deleteFile({
                params: { fileId },
            });

            if (res.status !== 200) {
                throw new Error("Error deleting file");
            }
        },
    });
}
